module.exports = __webpack_public_path__ + "static/media/2.dd2b6b5d.jpg";